import { render } from "./HeroCarouselComp.vue?vue&type=template&id=29b2c92e&scoped=true"
import script from "./HeroCarouselComp.vue?vue&type=script&lang=js"
export * from "./HeroCarouselComp.vue?vue&type=script&lang=js"

import "./HeroCarouselComp.vue?vue&type=style&index=0&id=29b2c92e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-29b2c92e"]])

export default __exports__